import { css as b, LitElement as f, nothing as c, html as h } from "lit";
import { query as g, property as o, state as y, customElement as w } from "lit/decorators.js";
import { classMap as m } from "lit/directives/class-map.js";
import { styleMap as v } from "lit/directives/style-map.js";
import { b as x } from "./styles-scZ6dVz-.js";
import { b as n, a as u } from "./events-CkEPl0SM.js";
import { g as k } from "./a11y-DxQW21Jt.js";
var $ = Object.defineProperty, V = Object.getOwnPropertyDescriptor, s = (e, t, r, a) => {
  for (var l = a > 1 ? void 0 : a ? V(t, r) : t, p = e.length - 1, d; p >= 0; p--)
    (d = e[p]) && (l = (a ? d(t, r, l) : d(l)) || l);
  return a && l && $(t, r, l), l;
};
let i = class extends f {
  constructor() {
    super(...arguments), this.sliderId = k("ark-slider"), this.value = 0, this.min = 0, this.max = 100, this.step = 1, this.size = "md", this.disabled = !1, this.showValue = !1, this.showTicks = !1, this.tickCount = 5, this.showLabels = !1, this.isDragging = !1;
  }
  get percentage() {
    return (this.value - this.min) / (this.max - this.min) * 100;
  }
  get formattedValue() {
    return this.formatValue ? this.formatValue(this.value) : String(this.value);
  }
  clampValue(e) {
    e = Math.max(this.min, Math.min(this.max, e));
    const t = Math.round((e - this.min) / this.step);
    return this.min + t * this.step;
  }
  getValueFromPosition(e) {
    const t = this.trackElement.getBoundingClientRect(), r = (e - t.left) / t.width, a = this.min + r * (this.max - this.min);
    return this.clampValue(a);
  }
  handleTrackClick(e) {
    if (this.disabled) return;
    const t = this.getValueFromPosition(e.clientX);
    this.value = t, n(this, u.CHANGE, { value: t });
  }
  handleThumbPointerDown(e) {
    if (this.disabled) return;
    this.isDragging = !0, e.target.setPointerCapture(e.pointerId);
    const t = (a) => {
      const l = this.getValueFromPosition(a.clientX);
      l !== this.value && (this.value = l, n(this, u.INPUT, { value: l }));
    }, r = (a) => {
      this.isDragging = !1, a.target.releasePointerCapture(a.pointerId), document.removeEventListener("pointermove", t), document.removeEventListener("pointerup", r), n(this, u.CHANGE, { value: this.value });
    };
    document.addEventListener("pointermove", t), document.addEventListener("pointerup", r);
  }
  handleKeydown(e) {
    if (this.disabled) return;
    let t = this.value;
    const r = (this.max - this.min) / 10;
    switch (e.key) {
      case "ArrowRight":
      case "ArrowUp":
        e.preventDefault(), t = this.clampValue(this.value + this.step);
        break;
      case "ArrowLeft":
      case "ArrowDown":
        e.preventDefault(), t = this.clampValue(this.value - this.step);
        break;
      case "PageUp":
        e.preventDefault(), t = this.clampValue(this.value + r);
        break;
      case "PageDown":
        e.preventDefault(), t = this.clampValue(this.value - r);
        break;
      case "Home":
        e.preventDefault(), t = this.min;
        break;
      case "End":
        e.preventDefault(), t = this.max;
        break;
      default:
        return;
    }
    t !== this.value && (this.value = t, n(this, u.INPUT, { value: t }), n(this, u.CHANGE, { value: t }));
  }
  renderTicks() {
    if (!this.showTicks) return c;
    const e = [], t = (this.max - this.min) / (this.tickCount - 1);
    for (let r = 0; r < this.tickCount; r++) {
      const a = Math.round(this.min + t * r);
      e.push(h`<span class="tick">${a}</span>`);
    }
    return h`<div class="ticks">${e}</div>`;
  }
  render() {
    const e = {
      slider: !0,
      [this.size]: !0,
      disabled: this.disabled,
      "show-value": this.showValue
    }, t = {
      thumb: !0,
      dragging: this.isDragging
    }, r = {
      width: `${this.percentage}%`
    }, a = {
      left: `${this.percentage}%`
    };
    return h`
      ${this.showLabels ? h`
            <div class="labels">
              <span class="label">${this.min}</span>
              <span class="label">${this.max}</span>
            </div>
          ` : c}

      <div class=${m(e)}>
        <div
          part="track"
          class="track"
          @click=${this.handleTrackClick}
        >
          <div
            part="fill"
            class="fill"
            style=${v(r)}
          ></div>

          <div
            part="thumb"
            class=${m(t)}
            style=${v(a)}
            role="slider"
            tabindex=${this.disabled ? -1 : 0}
            aria-valuemin=${this.min}
            aria-valuemax=${this.max}
            aria-valuenow=${this.value}
            aria-valuetext=${this.formattedValue}
            aria-disabled=${this.disabled}
            @pointerdown=${this.handleThumbPointerDown}
            @keydown=${this.handleKeydown}
          >
            <div part="value" class="value-tooltip">
              ${this.formattedValue}
            </div>
          </div>
        </div>
      </div>

      ${this.renderTicks()}

      <input
        type="hidden"
        name=${this.name ?? c}
        .value=${String(this.value)}
      />
    `;
  }
};
i.styles = [
  x,
  b`
      :host {
        display: block;
      }

      *,
      *::before,
      *::after {
        box-sizing: border-box;
      }

      .slider {
        position: relative;
        display: flex;
        align-items: center;
        width: 100%;
        touch-action: none;
        user-select: none;
      }

      .slider.disabled {
        opacity: 0.5;
        pointer-events: none;
      }

      /* Track sizes */
      .sm .track {
        height: 4px;
      }

      .md .track {
        height: 6px;
      }

      .lg .track {
        height: 8px;
      }

      /* Thumb sizes */
      .sm .thumb {
        width: 14px;
        height: 14px;
      }

      .md .thumb {
        width: 18px;
        height: 18px;
      }

      .lg .thumb {
        width: 22px;
        height: 22px;
      }

      .track {
        position: relative;
        flex: 1;
        background-color: var(--r5-bg-muted);
        border-radius: var(--r5-radius-full);
        cursor: pointer;
      }

      .fill {
        position: absolute;
        top: 0;
        left: 0;
        height: 100%;
        background-color: var(--r5-color-primary-500);
        border-radius: var(--r5-radius-full);
        pointer-events: none;
      }

      .thumb {
        position: absolute;
        top: 50%;
        transform: translate(-50%, -50%);
        background-color: var(--r5-bg);
        border: 2px solid var(--r5-color-primary-500);
        border-radius: var(--r5-radius-full);
        cursor: grab;
        transition: box-shadow var(--r5-duration-fast) var(--r5-ease-default);
      }

      .thumb:hover {
        box-shadow: 0 0 0 4px var(--r5-color-primary-100);
      }

      .thumb:focus {
        outline: none;
        box-shadow: 0 0 0 4px var(--r5-color-primary-100);
      }

      .thumb.dragging {
        cursor: grabbing;
        box-shadow: 0 0 0 6px var(--r5-color-primary-100);
      }

      /* Value tooltip */
      .value-tooltip {
        position: absolute;
        top: -2rem;
        left: 50%;
        transform: translateX(-50%);
        padding: var(--r5-space-1) var(--r5-space-2);
        background-color: var(--r5-bg-inverse);
        color: var(--r5-text-inverse);
        font-size: var(--r5-text-xs);
        border-radius: var(--r5-radius-md);
        white-space: nowrap;
        opacity: 0;
        visibility: hidden;
        transition: all var(--r5-duration-fast) var(--r5-ease-default);
      }

      .value-tooltip::after {
        content: '';
        position: absolute;
        top: 100%;
        left: 50%;
        transform: translateX(-50%);
        border: 4px solid transparent;
        border-top-color: var(--r5-bg-inverse);
      }

      .thumb:hover .value-tooltip,
      .thumb:focus .value-tooltip,
      .thumb.dragging .value-tooltip,
      .show-value .value-tooltip {
        opacity: 1;
        visibility: visible;
      }

      /* Ticks */
      .ticks {
        display: flex;
        justify-content: space-between;
        margin-top: var(--r5-space-2);
        padding: 0 var(--r5-space-1);
      }

      .tick {
        font-size: var(--r5-text-xs);
        color: var(--r5-text-muted);
      }

      /* Labels */
      .labels {
        display: flex;
        justify-content: space-between;
        margin-bottom: var(--r5-space-2);
      }

      .label {
        font-size: var(--r5-text-sm);
        color: var(--r5-text);
      }

      @media (prefers-reduced-motion: reduce) {
        .thumb,
        .value-tooltip {
          transition: none;
        }
      }
    `
];
s([
  g(".track")
], i.prototype, "trackElement", 2);
s([
  o({ type: Number })
], i.prototype, "value", 2);
s([
  o({ type: Number })
], i.prototype, "min", 2);
s([
  o({ type: Number })
], i.prototype, "max", 2);
s([
  o({ type: Number })
], i.prototype, "step", 2);
s([
  o({ type: String, reflect: !0 })
], i.prototype, "size", 2);
s([
  o({ type: Boolean, reflect: !0 })
], i.prototype, "disabled", 2);
s([
  o({ type: Boolean, attribute: "show-value" })
], i.prototype, "showValue", 2);
s([
  o({ type: Boolean, attribute: "show-ticks" })
], i.prototype, "showTicks", 2);
s([
  o({ type: Number, attribute: "tick-count" })
], i.prototype, "tickCount", 2);
s([
  o({ type: Boolean, attribute: "show-labels" })
], i.prototype, "showLabels", 2);
s([
  o({ attribute: !1 })
], i.prototype, "formatValue", 2);
s([
  o({ type: String })
], i.prototype, "name", 2);
s([
  y()
], i.prototype, "isDragging", 2);
i = s([
  w("ark-slider")
], i);
export {
  i as A
};
//# sourceMappingURL=ark-slider-iCXiD3F_.js.map
